module.exports = __webpack_public_path__ + "img/bg_input.01eea621.jpg";